import { EntitlementChips, EntitlementChip } from 'components/core/entitlement-chips/EntitlementChips'

export { EntitlementChips, EntitlementChip }
